import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Button from "../button";

const RefundModal = ({
  isOpen,
  handleClose,
  handleConfirm,
  deleteLoader,
  inVoiceId
}) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-[10px] bg-white p-6 text-left shadow-xl transition-all sm:my-8 w-full max-w-[480px]">
                <div>
                  <div className="mb-5 flex items-center justify-between gap-5 pb-2 border-b border-solid border-[#485868]">
                    <Dialog.Title
                      as="h3"
                      className="text-[17px] sm:text-[22px] leading-[160%] font-semibold text-customGray"
                    >
                      Refund Confirmation
                    </Dialog.Title>
                    <XMarkIcon
                      className="w-5 sm:w-6 h-5 sm:h-6 cursor-pointer hover:text-red-500"
                      aria-hidden="true"
                      onClick={handleClose}
                    />
                  </div>
                </div>
                <div className="pt-2">
                  <h6 className="text-sm md:text-base font-medium leading-[160%] text-customGray mb-6">
                  Are you sure you want to refund this package plan? 
                  </h6>
                </div>
                <div className="flex items-center justify-center gap-4 max-w-[180px] md:max-w-[390px] ml-auto w-full">
                  <Button
                    title="Guarantee Refund"
                    type="button"
                    classes={`bg-primary w-[580px] h-10 flex justify-center items-center text-sm md:text-base font-black leading-[160%] rounded-md text-white duration-500 ${
                      deleteLoader ? "pointer-events-none" : "cursor-pointer"
                    }`}
                    onClick={() => handleConfirm(inVoiceId , "guarantee-refund")}
                    buttonLoader={deleteLoader}
                  >
                    Guarantee Refund
                  </Button>
                  <Button
                    title="Refund"
                    type="button"
                    classes={`bg-primary w-full h-10 flex justify-center items-center text-sm md:text-base font-black leading-[160%] rounded-md text-white duration-500 ${
                      deleteLoader ? "pointer-events-none" : "cursor-pointer"
                    }`}
                    onClick={() => handleConfirm(inVoiceId, "refund")}
                    buttonLoader={deleteLoader}
                  >
                    Refund
                  </Button>
                  <Button
                    title="Cancel"
                    type="button"
                    classes="bg-red-500 w-full h-10 flex justify-center items-center text-sm md:text-base font-black leading-[160%] rounded-md text-white duration-500"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default RefundModal;
